import * as lenis from './lenis'

export default el => {
	const btn = el.querySelector('.js-group-product-btn');
	const zone = el.querySelector('.js-group-product-zone');
	var index = 1;
	var count = 1;

	if (!btn || !zone) return;

	btn.addEventListener('click', () => {
		index++;
		count++;
		ajax(index);
	})

	const ajax = (index) => {
		btn.classList.add('loading');

	    const ajax_url = ParamsData.wp_ajax_url;
	    const formData = new FormData();
	    const xhr = new XMLHttpRequest();

	    formData.append('action', 'group_product');
	    formData.append('index', index);
	    formData.append('count', count);
	    formData.append('name', el.dataset.groupProductName);
	    formData.append('type', el.dataset.groupProductType);

	    xhr.open('POST', ajax_url, true);
	    xhr.onreadystatechange = () => {
	        if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 0)) {
	        	const response = JSON.parse(xhr.response);

	        	// const html = document.createElement('div');
	        	// html.innerHTML = response.html;
	        	zone.insertAdjacentHTML('beforeend', response.html);
	        	// zone.appendChild(html);

	        	initRemoveBtns();

	        	conditioner.hydrate(zone);

	        	btn.classList.remove('loading');

	        	lenis.resize();

	        	if (count == 5) {
	        		btn.style.display = "none";
	        	}
	        }
	    };

	    xhr.send(formData);
	}

	const initRemoveBtns = () => {
		const removeBtns = el.querySelectorAll('.js-group-product-btn-remove');
		removeBtns.forEach(removeBtn => {
		  removeBtn.onclick = () => {
		  	count--;
		  	removeBtn.closest('.field').remove();
		  	initTitles();

		  	if (count < 5) {
		  		btn.style.display = "block";
		  	}
		  }
		})
	}

	const initTitles = () => {
		const titles = el.querySelectorAll('.js-group-product-title');
		titles.forEach((title, i) => {
			title.innerHTML = `${ParamsData.translations.product} ${i + 1}`;
		})
	}

	initRemoveBtns();
};
